const { REACT_APP_ASSIST_API_URL, REACT_APP_ASSIST_API_TOKEN } = process.env;

export const asAgentSearchApi = (value, category, requestPage) => {
  return {
    headers: {
      emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
    },
    apiUrl:
      REACT_APP_ASSIST_API_URL +
      `/as?keyword=${value}&g_code=${category}&req_page=${requestPage}`,
  };
};
